import $ from 'jquery';
import 'slick-carousel';
import zenscroll from "zenscroll";
import '@lottiefiles/lottie-player';

$('.jCarousel').slick();
$('.jHeroBanner').slick(
    {
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: "linear",
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true
    }
);

jQuery(function ($) {

    $('#menu-about-us a, #menu-services-menu a, #services-pagination a').attr('href', function (_, oldHref) {
        if ($(window).width() < 889) {
            return oldHref + "#aside_main_scroll";
        } else {
            return oldHref + "#aside_scroll";
        }
    });

    $('.jsHamburger').on('click', function() {
        $(this).toggleClass('is-active');
    });

    $('.jsMenuToggle').on('click', function() {
        $('.jsMobileNav').toggle();
        $('.jsNav').toggleClass('active');
        $('body').toggleClass('menu-open');
    });

    $('.jToggleAccordion').on('click', function() {
        var id = $(this).data('id');
        $(this).toggleClass('active');
        $('.jsAccordion_' + id).slideToggle();
        if ($(this).hasClass('active')) {
            $('button', this).attr('aria-expanded', 'true');
        } else {
            $('button', this).attr('aria-expanded', 'false');
        }

    });

    $('.jsTabButtons button').on('click', function(event) {
        event.preventDefault();
        var tabId = $(this).data('tab-button-id');
        var tabContainer = $(this).closest('.jsTabs');
        var tabContent = $(tabContainer).find("[data-tab-content='" + tabId + "']");
        var formContactId = $('form').find("[name='contact_id']");
        $('.jsTabButtons button', tabContainer).removeClass('active');
        $(formContactId).val(tabId);
        $(this).addClass('active');
        $('.jsTabContent', tabContainer).hide();
        $(tabContent).show();
    });
});

document.addEventListener( 'wpcf7mailsent', function( event ) {
    if(event.detail.contactFormId == 297) {
        window.location.href = '/free-business-debt-check/thank-you/';
    }
}, false );
